import { render, staticRenderFns } from "./PollVotersDetails.vue?vue&type=template&id=d8babac4&scoped=true"
import script from "./PollVotersDetails.vue?vue&type=script&lang=js"
export * from "./PollVotersDetails.vue?vue&type=script&lang=js"
import style0 from "./PollVotersDetails.vue?vue&type=style&index=0&id=d8babac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8babac4",
  null
  
)

export default component.exports